import React, { ComponentProps, FunctionComponent } from "react";

const CheckmarkIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      stroke: "currentColor",
      strokeWidth: 1.5,
      d: "M4.5 8L6.83333 10.5L11.5 5.5",
    })
  );
};

const ForwardRef = React.forwardRef(CheckmarkIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
